<script lang="ts">
  import { ENV } from "./util/env"

  import { setContext } from "svelte"

  import { recommendation } from "./stores/recommendation"

  import Header from "./components/Header/Header.svelte"
  import RecommendationCard from "./components/RecommendationCard/RecommendationCard.svelte"
  import ProductList from "./components/ProductList/ProductList.svelte"
  import Footer from "./components/Footer/Footer.svelte"
  import ExpertBio from "./components/Expert/ExpertBio.svelte"
  import BottomCta from "./components/BottomCTA/BottomCTA.svelte"
  import Loader from "./components/Loader/Loader.svelte"
  import ClearChoice from "./templates/ClearChoice/ClearChoice.svelte"

  let main: HTMLElement

  setContext("main", {
    getMain: () => main,
  })

  let loading = true

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: details = $recommendation.details

  // $: baseUrl = `https://dev-media.gethumankind.com/${details.brand.id}/assets/css`
  $: baseUrl = details
    ? `${ENV.MEDIA_SERVICE_URL}/${details.brand.id}/assets/css`
    : undefined

  function brandStyleLoadHandler () {
    loading = false
  }

  $: {
    window["_hjSettings"] = {
      hjid: ENV.HOTJAR_ID,
      hjsv: ENV.HOTJAR_SV,
    }
  }
</script>

<svelte:head>
  {#if details}
    <title>{details.brand.name} Recommendation</title>
    <link rel="icon" href={details.brand.favIcon} />
  {:else}
    <link rel="icon" type="image/png" href="/favicon.png" sizes="16x16" />
    <link rel="icon" type="image/png" href="/favicon@2x.png" sizes="32x32" />
  {/if}
  {#if baseUrl}
    <link
      on:load={brandStyleLoadHandler}
      rel="stylesheet"
      href={`${baseUrl}/recommendation.css`}
    />
  {/if}
  {#if window["_hjSettings"]}
    <!-- Hotjar Tracking Code for experts.gethumankind.com -->
    <script>
      (function (h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };

        a = o.getElementsByTagName("head")[0];
        r = o.createElement("script");
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
    </script>
  {/if}
</svelte:head>

{#if details}
  <Header />
  <main bind:this={main}>
    <div class="background" />
    <div class="content">
      <RecommendationCard />
      {#if details.brand.template === "ClearChoice"}
        <ClearChoice />
      {:else}
        <ProductList />
        <BottomCta />
        <ExpertBio />
      {/if}
    </div>
  </main>
  <Footer />
{/if}

{#if loading}
  <div class="loaderContainer" class:loading>
    <Loader />
  </div>
{/if}

<style lang="scss">
  .loaderContainer.loading {
    position: absolute;
    top: 0;
    width: 100%;
    background: white;
    height: 100%;
  }
  :global(html) {
    scroll-behavior: smooth;
  }
</style>
